import { SidebarMenuItem } from "../../types/types";
import { Link } from "react-router-dom";

interface props {
  item: SidebarMenuItem;
  active?: boolean;
}

export const SidebarMenuItemComponent: React.FC<props> = ({ item, active }) => (
  <Link
    to={item.url}
    className={`gm-sidebar-item${active ? ' is-active' : ''}`}
    title={item.label}
    aria-current={active ? 'page' : undefined}
  >
    <item.icon size={20} />
    <span className="gm-hide-collapsed">{item.label}</span>
  </Link>
);
